import { styled } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

export const LoaderContainer = styled('div')({
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  justifyContent: 'center'
});

export const SelectFileLabel = styled(Typography)(({ theme }) => ({
  marginRight: theme.spacing(2)
}));
